module.exports = __webpack_public_path__ + "img/ctrl-xx-stub--.fae82b6c.svg";